// styles
import styles from './progress-bar.module.scss'

type ProgressBarProps = {
	readonly percentage?: number
} & React.HTMLAttributes<HTMLDivElement>

const ProgressBar = (props: ProgressBarProps): JSX.Element => {
	const { className, percentage = 0, ...attr } = props

	let percentageOutput = Math.floor(percentage)
	if (percentageOutput < 0) percentageOutput = 0
	if (percentageOutput > 100) percentageOutput = 100

	return (
		<div
			{...attr}
			className={[styles.progressBar, className].join(' ').trim()}
		>
			<span className={styles.bar}>
				<span style={{ width: `${percentageOutput}%` }}></span>
			</span>
			<span className={styles.percentage}>{percentageOutput}%</span>
		</div>
	)
}

export default ProgressBar
